const commonTranslation = {
  mode: 'en',
  lang: '🇺🇸 English',

  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  add: 'Add',
  create: 'Create',
  save: 'Save',
  update: 'Update',
  transfer: 'Transfer',
  delete: 'Delete',
  reset: 'Reset',
  resetSuccess: 'Reset completed.',
  resetError: 'Reset failed.',
  duplicate: 'Duplicate',
  updateDelete: 'Update/Delete',
  completeMessage: 'completed.',
  cancelMessage: 'Canceled.',
  confirmMessage: 'Confirmed.',
  successMessage: 'Completed successfully.',
  addMessage: 'Added.',
  updateMessage: 'Updated.',
  transferMessage: 'Transferred.',
  deleteMessage: 'Deleted.',
  duplicateMessage: 'Duplicate complete!',
  validateMessage: 'is required.',
  invalidInputBarcodeMessage: 'Barcode must be 11 characters.',

  // Settings placeholders
  defaultValue: 'Default',
  none: 'None',

  download: 'Download',
  excelDownload: 'Download Spreadsheet',
  downloadReasonTitle: 'Download Reason',
  downloadReasonLabel: 'Reason',
  downloadReasonPlaceholder: 'Enter a reason for this download.',
  downloadReasonRequired: 'Please enter a download reason.',
  contextMenuDownloadWarningTitle: 'Right-click download is restricted',
  contextMenuDownloadWarningDescription:
    'Downloading videos or captures through the browser context menu is restricted. Use the download action provided on the screen if needed.',
  actionReasonTitle: 'Action Reason',
  actionReasonLabel: 'Reason',
  actionReasonPlaceholder: 'Enter a reason for this action.',
  actionReasonRequired: 'Please enter an action reason.',
  print: 'Print',
  languageSetting: 'Language',
  downloadCenter: 'Download Manager',
  themeSetting: 'Theme',
  themeLight: 'Light Mode',
  themeDark: 'Dark Mode',
  themeSystem: 'System',

  title: 'MDA: MommyBox Admin',
  hospital: 'Account',
  room: 'Location',
  selectHospital: 'Select Account',
  selectHospitalRoom: 'Select Room',
  selectDate: 'Select Date',
  inputBarcode: 'Enter Barcode',
  searchHospital: 'Search Account',
  searchTypeName: 'Search Type ',
  search: 'Search',
  date: 'Date',
  startSearchDate: 'Start Date',
  endSearchDate: 'End Date',

  new: 'New',
  total: 'Total',
  now: 'Now',
  dataCount: 'items',
  dataFilteredMessage1: 'items (',
  dataFilteredMessage2: 'items filtered from total)',
  table: {
    showTotal: '{{start}}-{{end}} of {{total}} items',
  },
  actions: 'Actions',
  refresh: 'Refresh',
  noInfo: 'No information',
  status: 'Status',
  itemLabel: 'Item',
  refreshed: 'Refreshed',
};

export default commonTranslation;
